var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';

/**
 * https://css-tricks.com/snippets/css/truncate-string-with-ellipsis/
 */
var truncateText = function truncateText() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var flexParent = options.flexParent,
    maxWidth = options.maxWidth,
    width = options.width;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    ", "\n  "])), flexParent ? "flex: 1;" : '', maxWidth ? "max-width: ".concat(typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px"), ";") : '', width ? "width: ".concat(typeof width === 'string' ? width : "".concat(width, "px"), ";") : '');
};
export { truncateText };